import React from 'react';
import {
  useTranslation,
  isMobile,
  gameConfigStore,
  userInfoStore,
  getAmountWithCurrency,
  convertAmount,
} from '@pascal/pascal-core';

import { doBetsStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';
import { BetTypeItem } from '../liveBetsItems/betType';

const trianglesIcons = {
  up: '-1',
  down: '',
  equal: '-2',
};

export const GameSpecificCheckHashPopupTopSection = ({ isFromBetHistory, currentData }) => {
  const t = useTranslation();
  const { roundData } = currentData;
  const { selectedBetHistoryItem } = doBetsStore;
  const { BetType } = globalTranslationKeys;

  return (
    <div className='res-cont-circle-wrp' dir='ltr'>
      {isFromBetHistory && (
        <div className='type-content'>
          <div className='type-text'>{t(BetType)}</div>
          <div className='type-count'>
            <BetTypeItem bet={selectedBetHistoryItem} />
          </div>
        </div>
      )}
      <div className='result-content'>
        <div
          className={`lucky-img ${
            roundData?.resultPoint < roundData?.previousPoint
              ? 'low'
              : roundData?.resultPoint > roundData?.previousPoint
              ? 'high'
              : 'equal'
          }`}
        >
          {roundData?.resultPoint && (
            <>
              <span className='round-first'>{roundData?.previousPoint}</span>
              <span className='round-second'>
                <i
                  className={`ui-lib-Triangle Triangle${
                    roundData?.resultPoint < roundData?.previousPoint
                      ? trianglesIcons.down
                      : roundData?.resultPoint > roundData?.previousPoint
                      ? trianglesIcons.up
                      : trianglesIcons.equal
                  }`}
                />
                {roundData?.resultPoint}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export const AboutHashInnerContent = ({ t }) => {
  const {
    FairnessModalTitle,
    FairnessP1,
    FairnessP2,
    FairnessP3,
    FairnessP4,
    FairnessP5,
    FairnessP6,
    FairnessP7,
    FairnessP8,
    FairnessP9,
    FairnessP10,
    FairnessP11,
    FairnessP12,
  } = globalTranslationKeys;
  return (
    <>
      {isMobile() && <p className='pr-f-text'>{t(FairnessModalTitle)}</p>}
      <p className='pr-f-text' title={t(FairnessP1)}>
        {t('FAIRNESS_P1')}
      </p>
      <p className='pr-f-text w-b-ba'>
        9191C03554E1B4D8AD6D6AD0463A6F50279002BD81B9C799DBD16898F989494C1586664A14AEBC3C7DF2341BE4817B3C90EE2FA893A8B13D6906DDE6F393F543
      </p>
      <p className='pr-f-text' title={t(FairnessP2)}>
        {t(FairnessP2)}
      </p>
      <p className='pr-f-text' title={t(FairnessP3)}>
        {t(FairnessP3)}
      </p>
      <p className='pr-f-text' title={t(FairnessP4)}>
        {t(FairnessP4)}
      </p>
      <p className='pr-f-text' title={t(FairnessP5)}>
        {t(FairnessP5)}
      </p>
      <p className='pr-f-text' title={t(FairnessP6)}>
        {t(FairnessP6)}
      </p>
      <p className='pr-f-text' title={t(FairnessP7)}>
        {t(FairnessP7)}
      </p>
      <p className='pr-f-text' title={t(FairnessP8)}>
        {t(FairnessP8)}
      </p>
      <p className='pr-f-text' title={t(FairnessP9)}>
        {t(FairnessP9)}
      </p>
      <p className='pr-f-text' title={t(FairnessP10)}>
        {t(FairnessP10)}
      </p>
      <p className='pr-f-text' title={t(FairnessP11)}>
        {t(FairnessP11)}
      </p>
      <p className='pr-f-text w-b-ba'>
        9191C03554E1B4D8AD6D6AD0463A6F50279002BD81B9C799DBD16898F989494C1586664A14AEBC3C7DF2341BE4817B3C90EE2FA893A8B13D6906DDE6F393F543
      </p>
      <p className='pr-f-text' title={t(FairnessP12)}>
        {t(FairnessP12)}
      </p>
    </>
  );
};

export const HelpPopupContent = ({ t }) => {
  const {
    GameRulesP1,
    GameRulesP2,
    GameRulesP3,
    GameRulesP4,
    GameRulesP5,
    GameRulesP6,
    GameRulesP7,
    GameRulesP8,
    GameRulesP9,
    GameRules10,
    GameRules11,
    GameRules12,
    GameRules13,
    GameRules14,
    GameRules15,
    GameRules16,
    AdditionalInfo,
    MinBet,
    MaxBet,
    Rtp,
    MaximumWin,
    CancelationMessage1,
    MalfunctionMessage2,
  } = globalTranslationKeys;

  const { maxBet, maxWin, minBet } = gameConfigStore.limits;
  const { currencySymbolOrCode } = userInfoStore;

  return (
    <>
      <p>{t(GameRulesP1)}</p>
      <p>{t(GameRulesP2)}</p>
      <p>{t(GameRulesP3)}</p>
      <p>{t(GameRulesP4)}</p>
      <p>{t(GameRulesP5)}</p>
      <p>{t(GameRulesP6)}</p>
      <p>{t(GameRulesP7)}</p>
      <p>{t(GameRulesP8)}</p>
      <p>{t(GameRulesP9)}</p>
      <p>{t(GameRules10)}</p>
      <p>{t(GameRules11)}</p>
      <p>{t(GameRules12)}</p>
      <p>{t(GameRules13)}</p>
      <p>{t(GameRules14)}</p>
      <p>{t(GameRules15)}</p>
      <p>{t(GameRules16)}</p>
      <>
        <p>
          <b>{t(AdditionalInfo)}</b>
        </p>
        <p>
          {t(MinBet)} - {getAmountWithCurrency({ amount: convertAmount(minBet) })}
        </p>
        <p>
          {t(MaxBet)} - {getAmountWithCurrency({ amount: convertAmount(maxBet) })}
        </p>
        <p>
          {t(MaximumWin)} - {getAmountWithCurrency({ amount: convertAmount(maxWin) })}
        </p>
      </>
      <p style={{ paddingBottom: 'unset' }}>{t(CancelationMessage1)}</p>
      <p>{t(MalfunctionMessage2)}</p>
      <p>{t(Rtp)}</p>
    </>
  );
};
